import apiClient from './client';

export interface PaperformDeletionDetail {
  id: string;
  form_type: string;
  participant_name: string | null;
  submitted_at: string;
  deleted_from_paperform_at: string;
}

export interface PaperformDeletionCount {
  form_type: string;
  count: number;
}

export interface PaperformDeletionsBannerState {
  shouldShow: boolean;
  totalCount: number;
  countsByFormType: PaperformDeletionCount[];
  deletions: PaperformDeletionDetail[];
  newestDeletionAt: string | null;
  windowDays: number;
}

export const paperformDeletionsApi = {
  async getBannerState(cohortId: string): Promise<PaperformDeletionsBannerState> {
    return apiClient.get<PaperformDeletionsBannerState>(
      `/api/cohorts/${cohortId}/paperform-deletions`,
    );
  },

  async dismiss(cohortId: string): Promise<{ dismissed_at: string }> {
    return apiClient.post<{ dismissed_at: string }>(
      `/api/cohorts/${cohortId}/paperform-deletions/dismiss`,
    );
  },
};

export default paperformDeletionsApi;
